import { watch } from 'vue'
import { useQuery } from '@tanstack/vue-query'
import { $axios, $queryClient } from '@/boot/initApi'

export default ({ activeSubstances }) => ({
  indexActiveSubstances: ({ enabled = true } = {}) => {
    const query = useQuery({
      queryKey: ['activeSubstances'],
      queryFn: async () => {
        try {
          const { data } = await $axios.get('api/active-substances')
          return data
        } catch (err) {
          console.error(err)
          return []
        }
      },
      enabled,
      staleTime: Infinity
    }, $queryClient)

    watch(query.data, val => {
      if (val) activeSubstances.value = val
    }, { immediate: true })

    return query
  }
})
